import { Map } from 'immutable'

import {
  FETCH_SAVED_CONSULTANTS_SUCCESS,
  SAVE_CONSULTANT,
  UNSAVE_CONSULTANT,
  SEARCH_SUCCESS,
  FETCH_CONSULTANT,
  FETCH_CONSULTANT_SUCCESS,
  UPDATE_CONSULTANT_INTERESTS_SUCCESS,
  UPDATE_EXPERIENCE_SUCCESS,
  CREATE_EXPERIENCE_SUCCESS,
  UPDATE_CONSULTANT_START_DATE_SUCCESS,
  UPDATE_USER_INFO_SUCCESS,
  DELETE_EXPERIENCE_SUCCESS,
  LOG_OUT_SUCCESS,
  FETCH_UNLISTED_CONSULTANTS_SUCCESS,
  APPROVE_CONSULTANT_SUCCESS,
  HIDE_CONSULTANT_SUCCESS,
} from 'actionTypes'

const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT_SUCCESS:
      return initialState
    case FETCH_UNLISTED_CONSULTANTS_SUCCESS:
      return Object.keys(action.consultants.toJS()).reduce(
        (consultants, id) => ({
          ...consultants,
          [id]: {
            ...consultants[id],
            ...action.consultants[id],
          },
        }),
        state
      )
    case APPROVE_CONSULTANT_SUCCESS:
      return {
        ...state,
        [action.consultantId]: {
          ...state[action.consultantId],
          listed: true,
        },
      }
    case HIDE_CONSULTANT_SUCCESS:
      return {
        ...state,
        [action.consultantId]: {
          ...state[action.consultantId],
          hidden: true,
        },
      }
    case UPDATE_USER_INFO_SUCCESS:
      return {
        ...state,
        [action.consultantId]: {
          ...state[action.consultantId],
          ...action.userInfo,
        },
      }
    case UPDATE_CONSULTANT_START_DATE_SUCCESS:
      return {
        ...state,
        [action.consultantId]: {
          ...state[action.consultantId],
          startDate: action.startDate,
        },
      }
    case CREATE_EXPERIENCE_SUCCESS:
    case UPDATE_EXPERIENCE_SUCCESS:
      return {
        ...state,
        [action.consultantId]: {
          ...state[action.consultantId],
          experience: (state[action.consultantId].experience || Map()).set(
            action.experienceId,
            action.experience
          ),
        },
      }
    case DELETE_EXPERIENCE_SUCCESS:
      return {
        ...state,
        [action.consultantId]: {
          ...state[action.consultantId],
          experience: (state[action.consultantId].experience || Map()).delete(
            action.experienceId
          ),
        },
      }
    case UPDATE_CONSULTANT_INTERESTS_SUCCESS:
      return {
        ...state,
        [action.consultantId]: {
          ...state[action.consultantId],
          interests: action.interests,
        },
      }
    case SEARCH_SUCCESS:
      return action.results.reduce(
        (consultants, consultant) => ({
          ...consultants,
          [consultant.id]: {
            ...consultants[consultant.id],
            ...consultant,
          },
        }),
        state
      )
    case FETCH_CONSULTANT:
      return {
        ...state,
        [action.consultantId]: {
          ...state[action.consultantId],
          pending: true,
        },
      }
    case FETCH_CONSULTANT_SUCCESS:
      return {
        ...state,
        [action.consultantId]: {
          ...state[action.consultantId],
          ...action.consultant,
          pending: false,
        },
      }
    case SAVE_CONSULTANT:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          saved: true,
        },
      }
    case UNSAVE_CONSULTANT:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          saved: false,
        },
      }
    case FETCH_SAVED_CONSULTANTS_SUCCESS:
      return Object.keys(action.savedConsultants || {}).reduce(
        (consultants, id) => ({
          ...consultants,
          [id]: {
            ...consultants[id],
            saved: true,
          },
        }),
        state
      )
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/consultants.js